import { create } from 'zustand';
import {
  HIDEOUT_MODULE_IDS,
  ZERO_EFFECTS,
  type HideoutEffects,
  type HideoutModuleState,
  type HideoutResponse,
  type HideoutUpgradeResult,
} from '@cradle7/shared';

const DEFAULT_MODULES: HideoutModuleState[] = HIDEOUT_MODULE_IDS.map((id) => ({
  id, level: 0, nextCost: 25, atMaxLevel: false,
}));

type HideoutState = {
  modules: HideoutModuleState[];
  effects: HideoutEffects;
  fishies: number;
};

type HideoutActions = {
  hydrateFromServer: (payload: HideoutResponse) => void;
  applyUpgradeResult: (payload: HideoutUpgradeResult) => void;
  reset: () => void;
};

const INITIAL: HideoutState = {
  modules: DEFAULT_MODULES,
  effects: { ...ZERO_EFFECTS },
  fishies: 0,
};

export const useHideoutStore = create<HideoutState & HideoutActions>((set) => ({
  ...INITIAL,
  hydrateFromServer: (payload) =>
    set({ modules: payload.modules, effects: payload.effects, fishies: payload.fishies }),
  applyUpgradeResult: (payload) =>
    set({ modules: payload.modules, effects: payload.effects, fishies: payload.fishies }),
  reset: () => set({ ...INITIAL }),
}));
